<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'LINK_EQUIPMENTS_DIALOG.TITLE' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      fxLayout="column"
      autocomplete="off"
      class="field-dialog__content__scroll p-24 dialog-link-equipment-content"
      fusePerfectScrollbar
    >
      <div class="search">
        <fc-text-input
          class="search__input"
          showSearchIcon="true"
          [control]="searchTerm"
          [label]="'LINK_EQUIPMENTS_DIALOG.SEARCH' | translate"
          [hint]="'LINK_EQUIPMENTS_DIALOG.SEARCH_HINT' | translate"
        >
        </fc-text-input>
      </div>

      <h2 class="title">
        {{ 'LINK_EQUIPMENTS_DIALOG.LINKED_EQUIPMENTS' | translate: { count: selectedCount, max: maxItems } }}
      </h2>

      <div class="fc-list">
        <fc-list-item
          class="fc-list__item"
          [item]="item"
          *ngFor="let item of items"
          (selectedChange)="onSelectedItemChange($event)"
        >
        </fc-list-item>
      </div>
    </form>
  </div>

  <div class="field-dialog__footer" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout="row">
    <button class="field-background" mat-raised-button (click)="save()" [disabled]="isSaving || isLoading">
      {{ 'LINK_EQUIPMENTS_DIALOG.SAVE' | translate }}
    </button>
  </div>
</div>
